module.exports = __webpack_public_path__ + "img/roof-flat.bcb1a756.svg";